import { basicBaseApi } from "./basicBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class StructureProblemApi extends basicBaseApi {
    public get ControllerName(): any {
        return 'structureProblem'
    }

    public saveOrupdate(structureProblem){
      return this.send(structureProblem,"saveOrupdate",Methods.POST)
    }
    

    public getProblemList(structureId,problemName){
      return this.send({structureId:structureId,problemName:problemName},'getProblemList',Methods.GET)
    }
   

    public getListByStructureId(structureIds){
      return this.send({structureIds:structureIds},'getListByStructureId',Methods.GET)
    }

    public getProblemListAll(problemName){
        return this.send({problemName:problemName},'getProblemListAll',Methods.GET)
    }
}